import { BaseResponse } from "../BaseResponse";

export class GenerateNewApiKeyRequest {
    description: string;
    data: string = "";
    publicKey: string = "";
    privateKey: string = "";
}